<template>
  <span class="currency-container">
    <span v-if="delta">
      <span v-if="value > 0" class="arrow positive">&#9650;</span>
      <span v-else-if="value < 0" class="arrow negative">&#9660;</span>
      <span v-else class="zero">-</span>
    </span>
    <span v-if="!(delta && Math.abs(value) <= 0)">
      <NumeraiTooltip :text="tooltip">
        <span
          :class="{
            daily_none: !value || value == 0,
            daily_positive: sign && value > 0,
            daily_negative: sign && value < 0,
            negative: value < 0,
          }"
        >
          {{ Math.abs(total).toLocaleString() }}
          <span v-if="!delta && !noNMR">NMR</span>
        </span>
      </NumeraiTooltip>
    </span>
  </span>
</template>

<script>
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    NumeraiTooltip,
  },
  props: {
    color: { type: Boolean, default: false },
    value: { type: [String, Number], default: '' },
    delta: { type: Boolean, default: false },
    sign: { type: Boolean, default: false },
    noNMR: { type: Boolean, default: false },
    customTooltip: { type: String, default: null },
    precision: { type: Number, default: 2 },
    tooltipUsd: { type: Boolean, default: true },
  },
  computed: {
    ...mapGetters(['nmrPrice']),
    total() {
      const total = parseFloat(this.value) || 0
      if (Math.abs(total) < 1 && total !== 0) {
        // If number is a fraction, use toPrecision
        return total.toPrecision(this.precision)
      }
      // else round
      return _.round(total, this.precision)
    },
    tooltip() {
      if (this.customTooltip) {
        return this.customTooltip
      } else {
        if (this.tooltipUsd) {
          if (this.value < 0) {
            return '- $' + Math.abs(this.totalInUSD).toLocaleString()
          } else {
            return '$' + this.totalInUSD.toLocaleString()
          }
        } else {
          return this.value + ' NMR'
        }
      }
    },
    totalInUSD() {
      return _.round(this.total * parseFloat(this.nmrPrice), this.precision)
    },
  },
}
</script>
<style scoped>
.currency-container {
  white-space: nowrap;
}

.zero {
  color: var(--color-subtle);
}
.positive {
  color: var(--color-text-positive);
}

.negative {
  color: var(--color-text-negative);
}

.negative::before {
  content: '-';
}

.daily_none {
  color: var(--color-subtle);
}

.daily_positive {
  color: var(--color-text-positive);
}

.daily_positive::before {
  content: '+';
}

.daily_negative {
  color: var(--color-text-negative);
}

.daily_negative::before {
  content: '-';
}
</style>
